export const WISHLIST_ITEM_TEST_ID = 'WISHLIST_ITEM_TEST_ID';
export const WISHLIST_INFO_BLOCK_TEST_ID = 'WISHLIST_INFO_BLOCK_TEST_ID';
